export default {
  "org_id": null,
  "supplier_id": null,
  "name": null,
  "type": "hotel",
  "status": "accepted",
  "context": "imemento",
  "images": [],
  "static": {
    "general": {
      "capacity": 0,
      "chain": {
        "part_of_chain": true,
        "name": null,
      },
      "classification": {
        "level": 1,
        "is_classified": false,
        "certificate_number": null,
      },
      "description": {
        "ro": null,
        "en": null,
      }
    },
    "financial": {
      "organization": {
        "name": null,
        "country": null,
        "city": null,
        "address": null,
        "cui": null,
        "reg_com": null,
        "bank": {
          "name": null,
          "iban": null,
          "currency": null,
        }
      }
    },
    "location": {
      "geo": {
        "lat": 0,
        "lon": 0
      },
      "address": {
        "country": null,
        "region": null,
        "city": null,
        "street": null,
        "number": null,
        "details": null,
        "postcode": null
      },
      "timezone": null,
    },
    "contact": {
      "hotel": {
        "website": null,
        "email": null,
        "phone": null,
        "fax": null
      },
      "people": []
    },
    "policies": {
      "check_in": {
        "start": null,
        "end": null,
      },
      "check_out": {
        "start": null,
        "end": null,
      },
      "weekend": [
        4,
        3
      ],
      "languages": {
        "mother": null,
        "spoken": [
          "ro",
          "en"
        ]
      },
      "payments": {
        "currency": null,
        "accepted_currencies": [ "EUR", "RON" ],
        "accepted_credit_cards": [ "mastercard", "visa" ]
      },
      "children": {
        "active": false,
        "infants": {
          "active": false,
          "ages": {
            "from": 0,
            "to": 2
          },
          "pricing": {
            "value": null,
            "type": null
          }
        },
        "small": {
          "active": false,
          "ages": {
            "from": 2,
            "to": 12
          },
          "pricing": {
            "value": null,
            "type": null
          }
        },
        "big": {
          "active": false,
          "ages": {
            "from": 12,
            "to": 18
          },
          "pricing": {
            "value": null,
            "type": null
          }
        }
      },
      "extrabeds": {
        "active": false,
        "pricing": {
          "value": 0,
          "type": "percent"
        }
      },
      "single_stay": {
        "active": false,
        "pricing": {
          "value": 0,
          "type": "percent"
        }
      },
      "terms_and_conditions": {
        "ro": null,
        "en": null
      }
    },
    "facilities": []
  }
}